import CoreDialog from '@Core/Components/Dialog/CoreDialog'
import { Alert, Button, Typography } from '@mui/material'
import { useBoolean, useRequest } from 'ahooks'
import React, { useEffect } from 'react'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import { getAuthDataSession, getCurrentWorkspaceSession } from '@Core/Helpers/Session'
import { get } from 'lodash'
import coreMyChannelService from '@Core/services/coreMyChannelService'
import { hideLoadingPage, showLoadingPage } from '@Core/Helpers/System'
import { isLocalhost, redirectUrl } from '@Core/Helpers/Url'
import { useCoreAuth } from '@Core/Provider/CoreAuthProvider/index'

// import PropTypes from 'prop-types'

export const useSwitchLms = props => {
	const [open, { setFalse, setTrue }] = useBoolean(false)
	const { user } = useCoreAuth()
	console.log('user', user)

	const switchLms = useRequest(coreMyChannelService.switchLms, {
		manual: true,
		onBefore: () => showLoadingPage(),
		onFinally: () => {
			hideLoadingPage()
		},
		onSuccess: result => {
			// console.log('===== switchLms result', result)
			redirectUrl('lms')
		}
	})

	useEffect(() => {
		// const user = getAuthDataSession()
		const type = get(user, 'onboarding_data.type', '')
		const is_allow_lms = get(user, 'onboarding_data.is_allow_lms', false)
		// console.log('============= type', type)
		// console.log('====> is_allow_lms', is_allow_lms)
		if (is_allow_lms && !isLocalhost()) {
			redirectUrl('lms')
		} else if (type === 'TEACHER') {
			setTrue()
		}
	}, [user])

	const renderDialogSwitchLms = () => {
		return (
			<CoreDialog
				open={open}
				handleClose={setFalse}
				maxWidth="md"
				dialogTitle="Chào mừng Thầy/Cô đến với EduQuiz LMS mới!"
				dialogContent={
					<div>
						<img src="/assets/images/banner/banner_switch_lms.png" alt="EduQuiz LMS" />
						<Typography variant="M16" component="div" className="my-3">
							Hệ thống LMS mới giúp Thầy/Cô quản lý lớp học dễ dàng hơn - Tạo đề thi nhanh chóng với AI,
							giao bài kiểm tra và theo dõi tiến độ học tập của học viên một cách hiệu quả.
						</Typography>
						<Alert
							severity="success"
							className="tour-ai-capabilities"
							icon={<AutoAwesomeIcon />}
							sx={{ mb: 2 }}
						>
							<Typography variant="SB14">🤖 Các tính năng nổi bật</Typography>
							<Typography variant="R14" component="div" sx={{ mt: 0.5 }}>
								✅ AI tạo đề thi nhanh, nhận diện công thức toán học, hoá học, vật lý phức tạp, trích
								xuất hình ảnh tự động
								<br />✅ Quản lý lớp học và học viên
								<br />
								✅ Giao bài kiểm tra và theo dõi tiến độ học tập
								<br />✅ Báo cáo kết quả chi tiết và phân tích hiệu suất học tập
							</Typography>
						</Alert>
					</div>
				}
				dialogAction={
					<>
						<Button
							variant="contained"
							// gradient="primary"
							onClick={() => {
								window.open('https://lms.eduquiz.vn', '_blank')
							}}
						>
							Tìm hiểu thêm
						</Button>
						<Button
							variant="contained"
							gradient="primary"
							onClick={() => {
								const params = {
									user_id: getAuthDataSession('id'),
									channel_id: getCurrentWorkspaceSession('id')
								}
								switchLms.run(params)
							}}
						>
							Chuyển đổi ngay
						</Button>
					</>
				}
			/>
		)
	}

	return { renderDialogSwitchLms }
}

// useSwitchLms.defaultProps = {}

// useSwitchLms.propTypes = {}
